import L, { Map } from 'leaflet';

export function convertMarkerSizeMetresToPixels(meters: number, map: Map, lat: number) {
  const earthCircumference = 40075017; // in meters
  const latitudeRadians = lat * (Math.PI / 180);
  const metersPerPixel = Math.cos(latitudeRadians) * earthCircumference / Math.pow(2, map.getZoom() + 8);

  return meters / metersPerPixel;
}
